'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validImgSrc;
var pathRegex = /^(.*\/)([^/]*)$/;

function validImgSrc(placeholder) {
  return pathRegex.test(placeholder) || placeholder.startsWith('data:image');
}